import { primaryBlue, gray60 } from './constants'

export const theme = {
  colors: {
    primaryBlue,
    gray60,
  },
}
